module.exports = __webpack_public_path__ + "img/keyboard_P.3cf7bc15.png";